import PropTypes from 'prop-types'
import { createContext, memo, useContext } from 'react'
import usePersona from './hooks/usePersona'

// The context
export const PersonaContext = createContext({})

// Use persona context utility
export const usePersonaContext = () => {
  const context = useContext(PersonaContext)

  return context
}

/**
 * The `PersonaProvider` is the context provider for the persona shop
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the react element
 */
function PersonaProvider (props) {
  const { children } = props
  const ctx = usePersona()

  return (
    <PersonaContext.Provider value={ctx}>{children}</PersonaContext.Provider>
  )
}

/** @type {object} */
PersonaProvider.propTypes = {
  children: PropTypes.node
}

/** @type {object} */
PersonaProvider.defaultProps = {
  children: []
}

// Memoize
export default memo(PersonaProvider)
